<template>
  <div
    v-if="!isSelfBookLoading && getCurrentSelfBook"
    id="container"
    class="sbook_st_detail"
  >
    <!-- Location START -->
    <Location />
    <!-- Location END -->

    <!-- 도서 기본 정보 START -->
    <div class="section full">
      <div class="inner">
        <div class="detail_book">
          <div class="eplist sbook">
            <div>
              <BaseSelfbook mode="edit" :selfbook="getCurrentSelfBook" />
              <div class="preview_btn_wrap">
                <a
                  target="_blank"
                  class="an_a"
                  :class="{ disabled: getCurrentSelfBook.webViewerYn === 'N' }"
                  @click="openSelfBook"
                  ><span class="c_icon ico_view_sbook"></span
                  ><span class="an_t">{{
                    $t('views.selfbook.selfbookdetail.4149')
                  }}</span></a
                >
              </div>
            </div>

            <div>
              <!-- *********************** -->
              <!-- DISPLAY CURRENT DETAILS -->
              <!-- *********************** -->
              <div v-if="!editingHeader">
                <div class="info_wrap">
                  <div class="row">
                    <p class="iconbox">
                      <span
                        class="meta_editer book"
                        :class="{
                          active: getCurrentSelfBook.buyTp.paper
                        }"
                        ><span class="an_i"></span
                        ><span class="an_t">BOOK</span></span
                      >
                      <span
                        class="meta_editer epub"
                        :class="{
                          active: getCurrentSelfBook.buyTp.ebook
                        }"
                        ><span class="an_i"></span
                        ><span class="an_t">eBOOK</span></span
                      >
                      <span
                        class="meta_editer pod"
                        :class="{
                          active: getCurrentSelfBook.buyTp.pod
                        }"
                        ><span class="an_i"></span
                        ><span class="an_t">POD</span></span
                      >
                    </p>

                    <h3 class="meta_title">{{ getCurrentSelfBook.title }}</h3>
                    <p class="meta_author">{{ getCurrentSelfBook.author }}</p>
                    <p class="meta_publisher">
                      {{ getCurrentSelfBook.publisher }}
                    </p>
                    <p class="meta_date">{{ getCurrentSelfBook.date }}</p>

                    <p class="meta_rate">
                      <span class="score_wrap">
                        <p class="meta_rate">
                          <span class="score_wrap">
                            <span class="inline-block">
                              <star-rating
                                :rating="getCurrentSelfBook.rating"
                                active-color="#FBE116"
                                :star-size="starSize"
                                :increment="increment"
                                :show-rating="showRating"
                                :read-only="readOnly"
                              />
                            </span>
                            <span class="score_score">{{
                              getCurrentSelfBook.rating
                            }}</span>
                            <span class="blind">{{
                              $t('common.ui.rating')
                            }}</span>
                            <span class="score_count_w">
                              (<span class="score_count">
                                {{ getCurrentSelfBook.reviewCount || 0 }} 명
                              </span>
                              ) <span class="blind"></span
                            ></span>
                          </span>
                        </p>
                      </span>
                    </p>
                  </div>

                  <div class="meta_detail">
                    <p class="meta_price">
                      <span class="blind">{{
                        $t('views.selfbook.selfbookdetail.4044')
                      }}</span>
                      <strong v-show="getCurrentSelfBook.price.ebook.listPrice">
                        <vue-intl-numberformat
                          locale="ko-KR"
                          class="price"
                          format-style="currency"
                          :currency="getCurrency.currency"
                          :number="getCurrentSelfBook.price.ebook.listPrice"
                        />
                      </strong>

                      <strong
                        v-show="!getCurrentSelfBook.price.ebook.listPrice"
                      >
                        <vue-intl-numberformat
                          locale="ko-KR"
                          class="price"
                          format-style="currency"
                          :currency="getCurrency.currency"
                          :number="0"
                        />
                      </strong>

                      <!--
                      <span class="discount"
                        ><span class="price">{{
                          getCurrentSelfBook.price
                            ? getCurrentSelfBook.price.toLocaleString('ko-KR')
                            : 0
                        }}</span>
                        <span class="currency">{{ $t('views.selfbook.selfbookdetail.currency') }}</span>
                      </span>
                      -->
                      <!-- FIXME: Need confirmation as to when this discount is used -->
                      <!-- <span class="percent"
                        >{{ $t('views.selfbook.selfbookdetail.1333') }}<span class="arrow">할인</span> )</span -->
                    </p>
                  </div>

                  <!-- IF Selfbook has been relisted (재개) then show this message while selfbook.status = 'pending' -->

                  <div
                    v-if="getCurrentSelfBook.status === 'pending'"
                    class="row mt20"
                  >
                    <div class="guide_txt no_icon">
                      <p class="cr">
                        <span class="quarter_web">{{
                          $t('views.selfbook.selfbookdetail.5478')
                        }}</span>
                        <span class="quarter_mobile">{{
                          $t('views.selfbook.selfbookdetail.4775')
                        }}</span>
                      </p>
                    </div>
                  </div>

                  <div
                    v-if="getCurrentSelfBook.status === 'adminStopped'"
                    class="row mt20 reason_wrap"
                  >
                    <div class="guide_txt no_icon">
                      <p class="cr">
                        {{ $t('views.selfbook.selfbookdetail.2905') }}
                      </p>
                      <div class="btn_wrap">
                        <button
                          type="button"
                          class="btn_open_reason"
                          @click="openReasonModal"
                        >
                          <span>{{
                            $t('views.selfbook.selfbookdetail.7673')
                          }}</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- SWITCH TO SELFBOOK METAINFO EDITING MODE -->
                  <div v-if="!editingHeader" class="btn_wrap atr">
                    <a class="an_a" @click="editHeader"
                      ><span class="c_icon ico_edit_sbook"></span
                      ><span class="an_t">{{
                        $t('views.selfbook.selfbookdetail.504')
                      }}</span>
                    </a>
                  </div>
                </div>

                <!-- IF selfbook.status = 'selling' Show the 판매 정지 button below -->
                <div v-if="getCurrentSelfBook.status === 'selling'">
                  <div class="guide_txt no_icon quarter_web">
                    <p>{{ $t('views.selfbook.selfbookdetail.4643') }}</p>
                  </div>
                  <div class="bdsi_f0">
                    <a class="box_btn dull" @click="setStatusToStopped"
                      ><span class="an_t">{{
                        $t('views.selfbook.selfbookdetail.3209')
                      }}</span></a
                    >
                  </div>
                </div>
              </div>

              <div v-if="!editingHeader" class="btn_wrap">
                <div class="bdsi_f3" style="float: right;">
                  <a class="box_btn dull" @click="deleteSelfbook"
                    ><span class="an_t">{{
                      $t('views.selfbook.selfbookdetail.6097')
                    }}</span></a
                  >
                </div>
              </div>

              <!-- Buttons shown when selfbook.status != 'selling' or 'pending' -->
              <!--
              <div
                v-if="
                  !showHeadEdit &&
                  getCurrentSelfBook.status !== 'selling' &&
                  getCurrentSelfBook.status !== 'pending' &&
                  $route.path == '/selfbook/modify'
                "
                class="btn_wrap"
              >  
              -->
              <!-- TODO: LIKELY TO BE A CONFIRM DELETE MODAL HERE, CURRENTLY NONE EXISTS FROM DESIGN/PUBLISHING. WAITING FOR DESIGN TEAM RESPONSE. -->
              <!--
                <div class="bdsi_f3">
                  <a class="box_btn dull" @click="deleteSelfbook"
                    ><span class="an_t">{{ $t('views.selfbook.selfbookdetail.3182') }}</span></a
                  >
                </div>
                <div class="bdsi_f3">
                  <a class="box_btn" @click="relistSelfbook"
                    ><span class="an_t">{{ $t('views.selfbook.selfbookdetail.6910') }}</span></a
                  >
                </div>
                <div class="bdsi_f3">
                  <button
                    type="button"
                    class="box_btn"
                    @click="openConfirmEditModal"
                  >
                    <span class="an_t">{{ $t('views.selfbook.selfbookdetail.1836') }}</span>
                  </button>
                </div>
                -->
              <!-- </div> -->
              <div v-if="!editingHeader" class="btn_wrap">
                <div class="bdsi_f3">
                  <button
                    type="button"
                    class="box_btn"
                    :class="{ dull: getCurrentSelfBook.editYn === 'N' }"
                    @click="openEditor"
                  >
                    <span class="an_t">{{
                      $t('views.selfbook.selfbookdetail.7819')
                    }}</span>
                  </button>
                </div>
              </div>

              <!-- ***************** -->
              <!-- DISPLAY EDIT MODE -->
              <!-- ***************** -->
              <div v-if="editingHeader" class="editer_form">
                <div class="editer_text_wrap n_line">
                  <input
                    id="modify-tile"
                    v-model="selfbookHeader.bookNm"
                    class="editer_input_t"
                    name="title"
                    :placeholder="$t('views.selfbook.selfbookdetail.8951')"
                  />
                </div>

                <div class="editer_text_wrap n_line">
                  <input
                    v-model="selfbookHeader.author"
                    class="editer_input_t"
                    name="author"
                    style="width: 144px;"
                    :placeholder="$t('views.selfbook.selfbookdetail.2679')"
                  />
                  <span class="gap">/</span>
                  <input
                    v-model="selfbookHeader.publisher"
                    class="editer_input_t"
                    name="publisher"
                    style="width: 144px;"
                    :placeholder="$t('views.selfbook.selfbookdetail.1528')"
                  />
                </div>

                <div class="editer_text_wrap n_line price_wrap">
                  <div class="th">
                    <span>{{ $t('views.selfbook.selfbookdetail.612') }}</span>
                  </div>
                  <div class="td">
                    <input
                      v-model="getCurrentSelfBook.price"
                      min="0"
                      class="editer_input_t"
                      name="price"
                      :title="$t('views.selfbook.selfbookdetail.9914')"
                      type="number"
                      :placeholder="$t('views.selfbook.selfbookdetail.948')"
                      style="width: 120px;"
                      oninput="validity.valid || (value = '')"
                      readonly
                    />
                    <!-- Not sure why this is here. Needs confirmation -->
                    <!-- <span class="percent"
                          >{{ $t('views.selfbook.selfbookdetail.2674') }}<span class="arrow">할인</span></span
                        > -->
                    <div class="ar">
                      <span v-show="getCurrentSelfBook.price.ebook.listPrice">
                        <vue-intl-numberformat
                          locale="ko-KR"
                          class="price"
                          format-style="currency"
                          :currency="getCurrency.currency"
                          :number="getCurrentSelfBook.price.ebook.listPrice"
                        />
                      </span>

                      <span v-if="!getCurrentSelfBook.price.ebook.listPrice">
                        <vue-intl-numberformat
                          locale="ko-KR"
                          class="price"
                          format-style="currency"
                          :currency="getCurrency.currency"
                          :number="0"
                        />
                      </span>
                    </div>
                    <!--
                    <div class="guide">
                      <p>{{ $t('views.selfbook.selfbookdetail.8173') }}</p>
                      <p>{{ $t('views.selfbook.selfbookdetail.2358') }}</p>
                    </div>
                    -->
                  </div>
                </div>

                <div v-if="!editingHeader" class="btn_wrap atr">
                  <a class="an_a" @click="editHeader"
                    ><span class="c_icon ico_edit_sbook"></span
                    ><span class="an_t">{{
                      $t('views.selfbook.selfbookdetail.3052')
                    }}</span></a
                  >
                </div>

                <!-- Selfbook.color selector -->
                <div class="editer_select_cover">
                  <p>{{ $t('views.selfbook.selfbookdetail.8405') }}</p>
                  <div class="text_label">
                    <label class="cursor"
                      ><input
                        v-model="selfbookHeader.thumbTp"
                        type="radio"
                        name="select_cover"
                        class="chk_cover display-none"
                        value="A"
                        checked
                      /><em></em
                      ><span class="blind">{{
                        $t('views.selfbook.selfbookdetail.blue')
                      }}</span></label
                    >
                    <label class="cursor"
                      ><input
                        v-model="selfbookHeader.thumbTp"
                        type="radio"
                        name="select_cover"
                        class="chk_cover display-none"
                        value="B"
                      /><em></em
                      ><span class="blind">{{
                        $t('views.selfbook.selfbookdetail.orange')
                      }}</span></label
                    >
                    <label class="cursor"
                      ><input
                        v-model="selfbookHeader.thumbTp"
                        type="radio"
                        name="select_cover"
                        class="chk_cover display-none"
                        value="C"
                      /><em></em
                      ><span class="blind">{{
                        $t('views.selfbook.selfbookdetail.green')
                      }}</span></label
                    >
                  </div>
                </div>
              </div>

              <!-- Buttons to save or cancel edits made -->
              <div v-if="editingHeader" class="btn_wrap ar">
                <div>
                  <button class="box_btn dull" @click="editHeader">
                    <span class="an_t">{{
                      $t('library.deletemodal.cancel')
                    }}</span>
                  </button>
                </div>
                <div>
                  <button class="box_btn" @click.prevent="saveHeadChanges">
                    <span class="an_t">{{
                      $t('library.deletemodal.save')
                    }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Removed this button because it doesn't make sense in the UI flow. Editor should only be accessible after saving the meta data for the file. Confirmed with 옥이사 -->
      <!-- <div class="btn_wrap">
                  <div class="bdsi_f0">
                    <a href="javascript:void(0)" class="box_btn"
                      ><span class="an_t">{{ $t('views.selfbook.selfbookdetail.8641') }}</span></a
                    >
                  </div>
                </div> -->

      <!-- MODAL TO DISPLAY REASON ADMIN STOPPED SALE OF THIS SELFBOOK -->
      <!--
      <transition name="modal-fade">
        <ReasonStoppedModal
          v-if="showReasonModal"
          :selfbook="selfbook"
          @close="closeReasonModal"
        />
      </transition>
      -->

      <!-- MODAL SHOWN BEFORE REPUBLISHING A SELFBOOK WITH STATUS 'stopped' -->
      <!--
      <transition name="modal-fade">
        <ConfirmEditModal
          v-if="showConfirmEditModal"
          @close="closeConfirmEditModal"
        />
      </transition>
      -->
    </div>
    <!-- 도서 기본 정보 END -->

    <!-- 도서 세부 정보 -->
    <div class="section fill">
      <div class="inner line">
        <div class="detail_book_introduce">
          <BookDetailBox class="detailMargin" :book="getCurrentSelfBook" />

          <!-- ****************** -->
          <!-- DISPLAY CATEGORIES -->
          <!-- ****************** -->
          <div v-if="getCurrentSelfBook" class="box">
            <h3 class="sub_tit">
              {{ $t('views.selfbook.selfbookdetail.3310') }}
            </h3>
            <div v-if="!editCategories" class="box_inner">
              <p
                v-for="(cat, idx) in getCurrentSelfBook.catgryPathList"
                :key="idx"
                class="meta_itemlege"
              >
                <span> {{ cat.catgryPath }} </span>
              </p>
            </div>
            <!-- selfbook edit btn -->
            <div v-if="!editCategories" class="btn_wrap atr">
              <a class="an_a" @click="toggleEditCategories"
                ><span class="c_icon ico_edit_sbook"></span
                ><span class="an_t">{{
                  $t('views.selfbook.selfbookdetail.8046')
                }}</span></a
              >
            </div>

            <!-- ********************************** -->
            <!-- STAGED DROPDOWN CATEGORY SELECTION -->
            <!-- ********************************** -->
            <!-- Main Category Selection -->
            <div v-if="editCategories" class="editer_form_wrap">
              <div class="editer_form">
                <div
                  v-for="(cat, index) in updatedCategories"
                  :key="index"
                  class="row college_group"
                >
                  <BookCategoryRow :category="cat" />
                  <button
                    type="button"
                    class="btn_delete_college an_a"
                    @click="deleteCategoryRow(index)"
                  >
                    <span class="c_icon"></span><span class="an_t">삭제</span>
                  </button>
                </div>
                <button class="btn_insert_college an_a" @click="addCategoryRow">
                  <span class="an_t">{{
                    $t('views.selfbook.selfbookdetail.2596')
                  }}</span>
                </button>
              </div>
              <div class="btn_wrap ar">
                <div>
                  <button class="box_btn dull" @click="toggleEditCategories">
                    <span class="an_t">{{
                      $t('library.deletemodal.cancel')
                    }}</span>
                  </button>
                </div>
                <div>
                  <button class="box_btn" @click="saveCategoryChanges">
                    <span class="an_t">{{
                      $t('library.deletemodal.save')
                    }}</span>
                  </button>
                </div>
              </div>
            </div>
            <!-- End Edit Box -->
          </div>

          <TextareaBox
            :title="$t('views.selfbook.selfbookdetail.5369')"
            :text.sync="description"
            mode="view"
            @save="saveDescription"
            @cancel="setDefault"
          />

          <TextareaBox
            :title="$t('views.selfbook.selfbookdetail.4551')"
            :text.sync="contents"
            mode="view"
            @save="saveContents"
            @cancel="setDefault"
          />
        </div>
      </div>
    </div>

    <!-- SALES VOLUME CHART WRAP -->
    <!-- <SalesChart :chart-data="chartData" /> -->

    <!-- Review -->
    <!-- <ReviewBox :book="getCurrentSelfBook" /> -->

    <!-- TODO: @TIM Add the 신고센터 box here later from 1-8-1 Selfbook_detail -->
  </div>
</template>

<script>
import { niaMode } from '@/store/constants'
import StarRating from 'vue-star-rating'
//import SalesChart from '@/components/selfbook/SalesChart.vue'
//import ReviewBox from '@/components/library/ReviewBox.vue'
import TextareaBox from '@/components/library/TextareaBox.vue'
//import BookCategoryBox from '@/components/library/BookCategoryBox.vue'
import BookDetailBox from '@/components/library/BookDetailBox.vue'
import BookCategoryRow from '@/components/library/BookCategoryRow.vue'

//import SelfbookDetailHead from '@/components/selfbook/SelfbookDetailHead.vue'
import Location from '@/components/selfbook/Location.vue'
import { mapGetters } from 'vuex'

import {
  SELFBOOK_GET,
  SELFBOOK_UPDATE,
  SELFBOOK_DELETE,
  STORE_CATEGORIES_GET_ALL
} from '@/store/types'

export default {
  name: 'SelfbookDetail',
  components: {
    Location,
    //SelfbookDetailHead,
    BookDetailBox,
    //BookCategoryBox,
    TextareaBox,
    StarRating,
    BookCategoryRow
    //ReviewBox,
    //SalesChart
  },
  data() {
    return {
      niaMode,
      editingHeader: false,
      showCategoriesEdit: false,
      showDescriptionEdit: false,
      showContentsEdit: false,

      selfbookHeader: {},
      description: '',
      contents: '',
      error: null,
      editCategories: false,

      starSize: 15,
      starSizeEdit: 28,
      increment: 0.5,
      showRating: false,
      readOnly: true,
      updatedCategories: [
        {
          parent: {},
          child: {},
          children: {}
        }
      ],

      dropdowns: [
        {
          id: 1
        },
        {
          id: 2
        },
        {
          id: 3
        }
      ]
      /*
      chartData: {
        monthlySales: [
          { date: '12.02.20', count: 5 },
          { date: '12.02.20', count: 5 }
        ],
        // TODO: Year filter should be calculated server side
        // This is just temp data
        // Available years should start at 2020 and go to current year
        years: [2020, 2021],
        filters: ['판매량', '판매금액'],
        salesCount: 123,
        salesPrice: 456
      }
      */
    }
  },
  computed: {
    ...mapGetters([
      'getAllSelfbookCategories',
      'getCurrentSelfBook',
      'isSelfBookLoading',
      'getMainAllCategories',
      'getCurrency'
    ])
  },
  async mounted() {
    const { id } = this.$route.params
    if (!this.getCurrentSelfBook || this.getCurrentSelfBook.id !== id) {
      await this.$store.dispatch(SELFBOOK_GET, { id })
    }
    if (!this.getMainAllCategories) {
      await this.$store.dispatch(STORE_CATEGORIES_GET_ALL)
    }
    this.setDefault()
  },
  methods: {
    openSelfBook() {
      if (this.getCurrentSelfBook.webViewerYn === 'N') {
        return
      }
      window.open(
        this.getCurrentSelfBook.webViewerUrl,
        '_blank',
        'toolbar=0,location=0,menubar=0'
      )
    },
    openEditor() {
      if (this.getCurrentSelfBook.editYn === 'N') {
        return
      }
      window.open(
        this.getCurrentSelfBook.editUrl,
        '_blank',
        'toolbar=0,location=0,menubar=0'
      )
    },
    setDefault() {
      this.selfbookHeader = {
        bookNm: this.getCurrentSelfBook.bookNm,
        author: this.getCurrentSelfBook.author,
        publisher: this.getCurrentSelfBook.publisher,
        thumbTp: this.getCurrentSelfBook.color
      }
      this.description = this.getCurrentSelfBook.description
      this.contents = this.getCurrentSelfBook.bookToc

      this.updatedCategories = this.getCurrentSelfBook.catgryPathList.map(
        (cat) => {
          return {
            parent: {
              catgryNm: cat.catgryPath.split('>')[0].replace(/\s/g, ''),
              catgryCd: cat.catgryCdGrp.split('@')[0]
            },
            child: {
              catgryNm: cat.catgryPath.split('>')[1].replace(/\s/g, ''),
              catgryCd: cat.catgryCdGrp.split('@')[1]
            },
            children: {
              catgryNm:
                cat.catgryPath.split('>').length > 2
                  ? cat.catgryPath.split('>')[2].replace(/\s/g, '')
                  : '',
              catgryCd:
                cat.catgryCdGrp.split('@').length > 2
                  ? cat.catgryCdGrp.split('@')[2]
                  : ''
            }
          }
        }
      )

      this.editCategories = false
      this.editingHeader = false
      this.showCategoriesEdit = false
      this.showDescriptionEdit = false
      this.showContentsEdit = false
    },
    async deleteSelfbook() {
      const { id } = this.$route.params
      try {
        await this.$store.dispatch(SELFBOOK_DELETE, id)
        this.$router.push({ name: 'selfbook' })
      } catch (err) {
        this.error = err
      }
    },
    editHeader() {
      this.editingHeader = !this.editingHeader
    },
    toggleEditCategories() {
      this.editCategories = !this.editCategories
    },
    async saveHeadChanges() {
      const selfbook = { ...this.selfbookHeader }
      const { id } = this.$route.params

      try {
        await this.$store.dispatch(SELFBOOK_UPDATE, {
          id,
          selfbook,
          updateType: 'BOOK'
        })
        this.setDefault()
        this.editHeader()
      } catch (err) {
        this.error = err
      }
    },
    deleteCategoryRow(index) {
      this.updatedCategories.splice(index, 1)
    },
    addCategoryRow() {
      this.updatedCategories.push({
        parent: {},
        child: {},
        children: {}
      })
    },
    async saveCategoryChanges() {
      const catgryList = this.updatedCategories.map((cat) => {
        return `${cat.parent.catgryCd}@${cat.child.catgryCd}${
          cat.children.catgryCd ? `@${cat.children.catgryCd}` : ''
        }`
      })

      const selfbook = { catgryList }
      const { id } = this.$route.params

      try {
        await this.$store.dispatch(SELFBOOK_UPDATE, {
          id,
          selfbook,
          updateType: 'CTGRY'
        })
        this.setDefault()
      } catch (err) {
        this.error = err
      }
    },
    async saveDescription() {
      const selfbook = { bookDesc: this.description }
      const { id } = this.$route.params

      try {
        await this.$store.dispatch(SELFBOOK_UPDATE, {
          id,
          selfbook,
          updateType: 'INTRO'
        })
        this.setDefault()
      } catch (err) {
        this.error = err
      }
    },
    async saveContents() {
      const selfbook = { bookIndex: this.contents }
      const { id } = this.$route.params

      try {
        await this.$store.dispatch(SELFBOOK_UPDATE, {
          id,
          selfbook,
          updateType: 'TOC'
        })
        this.setDefault()
      } catch (err) {
        this.error = err
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.editer_form {
  .editer_select_cover {
    .text_label {
      input[value='A'] + em {
        // background: url('~@/assets/images/cover_chk_blue.png') center center
        //   no-repeat;
      }
      input[value='B'] + em {
        // background: url('~@/assets/images/cover_chk_orange.png') center center
        //   no-repeat;
      }
      input[value='C'] + em {
        // background: url('~@/assets/images/cover_chk_green.png') center center
        //   no-repeat;
      }
    }
  }
  .editer_text_wrap {
    input:read-only {
      background: #f0f5fa;
      border: 1px solid rgba(119, 136, 153, 0.6);
      font-size: 15px;
      line-height: 28px;
      letter-spacing: -0.03em;
      color: #777777;
    }
  }
}

.preview_btn_wrap .disabled {
  background-color: #b3b5b7;
  border: 1px solid #b3b5b7;
}
</style>
